import api from './api';

const inventoryService = {
  // ===== PRODUTOS =====
  
  // Listar produtos
  getProducts: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    
    const response = await api.get(`/inventory/products?${queryParams.toString()}`);
    return response.data;
  },

  // Obter produto específico
  getProduct: async (id) => {
    const response = await api.get(`/inventory/products/${id}`);
    return response.data;
  },

  // Obter detalhes completos do produto (com variantes, estoque e histórico)
  getProductDetails: async (id) => {
    const response = await api.get(`/inventory/products/${id}/details`);
    return response.data;
  },

  // Obter estoque por armazém
  getStockByWarehouse: async (id) => {
    const response = await api.get(`/inventory/products/${id}/stock-by-warehouse`);
    return response.data;
  },

  // Criar produto
  createProduct: async (productData) => {
    const response = await api.post('/inventory/products', productData);
    return response.data;
  },

  // Upload de imagem de produto (Cloudinary)
  uploadProductImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/inventory/products/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Gerar próximo SKU baseado na categoria
  getNextSku: async (categoria) => {
    const response = await api.get('/inventory/products/next-sku', {
      params: { categoria }
    });
    return response.data;
  },

  // Atualizar produto
  updateProduct: async (id, productData) => {
    const response = await api.put(`/inventory/products/${id}`, productData);
    return response.data;
  },

  // Deletar produto (desativação lógica)
  deleteProduct: async (id) => {
    const response = await api.delete(`/inventory/products/${id}`);
    return response.data;
  },

  // Excluir produto permanentemente em cascata (com senha do gerente)
  forceDeleteProduct: async (id, password) => {
    const response = await api.post(`/inventory/products/${id}/force-delete`, { password });
    return response.data;
  },

  // Batch delete products
  deleteProductsBatch: async (ids) => {
    const response = await api.post('/inventory/products/batch-delete', { ids });
    return response.data;
  },

  // ===== VARIANTES =====
  
  // Criar variante
  createVariant: async (produtoId, variantData) => {
    const response = await api.post(`/inventory/products/${produtoId}/variants`, variantData);
    return response.data;
  },

  // Atualizar variante
  updateVariant: async (id, variantData) => {
    const response = await api.put(`/inventory/variants/${id}`, variantData);
    return response.data;
  },

  // Deletar variante
  deleteVariant: async (id) => {
    const response = await api.delete(`/inventory/variants/${id}`);
    return response.data;
  },

  // ===== ESTOQUE =====
  
  // Listar estoque
  getStock: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    
    const response = await api.get(`/inventory/stock?${queryParams.toString()}`);
    return response.data;
  },

  // Listar movimentos de estoque
  getStockMovements: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    
    const response = await api.get(`/inventory/stock-movements?${queryParams.toString()}`);
    return response.data;
  },

  // Ajustar estoque
  adjustStock: async (stockData) => {
    const response = await api.post('/inventory/stock/adjust', stockData);
    return response.data;
  },

  // Transferir estoque entre armazéns
  transferStock: async (transferData) => {
    const response = await api.post('/inventory/stock/transfer', transferData);
    return response.data;
  },

  // ===== DADOS AUXILIARES =====
  
  // Listar categorias
  getCategories: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    
    const response = await api.get(`/inventory/categories?${queryParams.toString()}`);
    return response.data;
  },

  // Listar marcas
  getBrands: async () => {
    const response = await api.get('/inventory/brands');
    return response.data;
  },

  // Listar unidades
  getUnits: async () => {
    const response = await api.get('/inventory/units');
    return response.data;
  },

  // Criar categoria
  createCategory: async (categoryData) => {
    const response = await api.post('/inventory/categories', categoryData);
    return response.data;
  },

  // Atualizar categoria
  updateCategory: async (id, categoryData) => {
    const response = await api.put(`/inventory/categories/${id}`, categoryData);
    return response.data;
  },

  // Excluir categoria
  deleteCategory: async (id) => {
    const response = await api.delete(`/inventory/categories/${id}`);
    return response.data;
  },

  // Criar marca
  createBrand: async (brandData) => {
    const response = await api.post('/inventory/brands', brandData);
    return response.data;
  },

  // Atualizar marca
  updateBrand: async (id, brandData) => {
    const response = await api.put(`/inventory/brands/${id}`, brandData);
    return response.data;
  },

  // Remover (desativar) marca
  deleteBrand: async (id) => {
    const response = await api.delete(`/inventory/brands/${id}`);
    return response.data;
  },

  // Criar unidade
  createUnit: async (unitData) => {
    const response = await api.post('/inventory/units', unitData);
    return response.data;
  },

  // Atualizar unidade
  updateUnit: async (id, unitData) => {
    const response = await api.put(`/inventory/units/${id}`, unitData);
    return response.data;
  },

  // Remover (desativar) unidade
  deleteUnit: async (id) => {
    const response = await api.delete(`/inventory/units/${id}`);
    return response.data;
  },

  // ===== CORES =====

  // Listar cores
  getCores: async () => {
    const response = await api.get('/inventory/cores');
    return response.data;
  },

  // Criar cor
  createCor: async (corData) => {
    const response = await api.post('/inventory/cores', corData);
    return response.data;
  },

  // Atualizar cor
  updateCor: async (id, corData) => {
    const response = await api.put(`/inventory/cores/${id}`, corData);
    return response.data;
  },

  // Remover (desativar) cor
  deleteCor: async (id) => {
    const response = await api.delete(`/inventory/cores/${id}`);
    return response.data;
  },

  // ===== TAMANHOS =====

  // Listar tamanhos
  getTamanhos: async () => {
    const response = await api.get('/inventory/tamanhos');
    return response.data;
  },

  // Criar tamanho
  createTamanho: async (tamanhoData) => {
    const response = await api.post('/inventory/tamanhos', tamanhoData);
    return response.data;
  },

  // Atualizar tamanho
  updateTamanho: async (id, tamanhoData) => {
    const response = await api.put(`/inventory/tamanhos/${id}`, tamanhoData);
    return response.data;
  },

  // Remover (desativar) tamanho
  deleteTamanho: async (id) => {
    const response = await api.delete(`/inventory/tamanhos/${id}`);
    return response.data;
  },

  // Listar armazéns
  getWarehouses: async () => {
    const response = await api.get('/inventory/warehouses');
    return response.data;
  },

  // Criar armazém
  createWarehouse: async (warehouseData) => {
    const response = await api.post('/inventory/warehouses', warehouseData);
    return response.data;
  },

  // Atualizar armazém
  updateWarehouse: async (id, warehouseData) => {
    const response = await api.put(`/inventory/warehouses/${id}`, warehouseData);
    return response.data;
  },

  // Remover (desativar) armazém
  deleteWarehouse: async (id) => {
    const response = await api.delete(`/inventory/warehouses/${id}`);
    return response.data;
  },

  // Listar impostos
  getTaxes: async () => {
    const response = await api.get('/inventory/taxes');
    return response.data;
  },

  // ===== ESTATÍSTICAS =====
  
  // Obter estatísticas
  getStats: async () => {
    const response = await api.get('/inventory/stats');
    return response.data;
  },

  // ===== PREÇOS POR FORNECEDOR =====
  
  // Listar preços por fornecedor de uma variante
  getVariantSupplierPrices: async (varianteId) => {
    const response = await api.get(`/inventory/variants/${varianteId}/supplier-prices`);
    return response.data;
  },

  // Adicionar/atualizar preço de fornecedor
  upsertSupplierPrice: async (varianteId, priceData) => {
    const response = await api.post(`/inventory/variants/${varianteId}/supplier-prices`, priceData);
    return response.data;
  },

  // Remover preço de fornecedor
  deleteSupplierPrice: async (id) => {
    const response = await api.delete(`/inventory/supplier-prices/${id}`);
    return response.data;
  },

  // Listar fornecedores (usando o serviço de suppliers)
  getSuppliers: async () => {
    const response = await api.get('/suppliers');
    return response.data;
  },

  // Listar variantes para orçamento (com preço de venda, mesmo que estoque zerado)
  getVariantsForBudget: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    
    const response = await api.get(`/inventory/variants-for-budget?${queryParams.toString()}`);
    return response.data;
  },

  // ===== SETORES =====

  // Listar setores
  getSetores: async (params = {}) => {
    const response = await api.get('/inventory/setores', { params });
    return response.data;
  },

  // Obter setor específico
  getSetor: async (id) => {
    const response = await api.get(`/inventory/setores/${id}`);
    return response.data;
  },

  // Criar setor
  createSetor: async (data) => {
    const response = await api.post('/inventory/setores', data);
    return response.data;
  },

  // Atualizar setor
  updateSetor: async (id, data) => {
    const response = await api.put(`/inventory/setores/${id}`, data);
    return response.data;
  },

  // Remover (desativar) setor
  deleteSetor: async (id) => {
    const response = await api.delete(`/inventory/setores/${id}`);
    return response.data;
  },

  // Gerar QR code para produto
  generateProductQRCode: async (productId) => {
    const response = await api.get(`/inventory/products/${productId}/qrcode`);
    return response.data;
  },

  // ===== ETIQUETAS DE ESTOQUE =====

  generateStockLabels: async (stockId, quantity) => {
    const response = await api.post(`/inventory/stock/${stockId}/labels`, { quantity });
    return response.data;
  },

  getStockLabels: async (stockId) => {
    const response = await api.get(`/inventory/stock/${stockId}/labels`);
    return response.data;
  },

  getStockByQRCode: async (code) => {
    const response = await api.get(`/inventory/stock/labels/${code}`);
    return response.data;
  },

  generateLabelQRCode: async (code) => {
    const response = await api.get(`/inventory/stock/label/${code}/qrcode`);
    return response.data;
  },

  printSmallLabel: async (code) => {
    const response = await api.get(`/inventory/stock/label/${code}/print`);
    return response.data;
  },

  printBatchLabels: async (stockId, quantity) => {
    const response = await api.post(`/inventory/stock/${stockId}/labels/print`, { quantity });
    return response.data;
  },

  getLabelsByVariant: async (varianteId) => {
    const response = await api.get(`/inventory/variants/${varianteId}/labels`);
    return response.data;
  },

  printLabelsByVariant: async (varianteId, quantity) => {
    const response = await api.post(`/inventory/variants/${varianteId}/labels/print`, { quantity });
    return response.data;
  },

  // ===== RETALHOS E SOBRAS DE MDF =====
  getRetalhos: async (params = {}) => {
    const response = await api.get('/inventory/retalhos', { params });
    return response.data;
  },

  createRetalho: async (data) => {
    const response = await api.post('/inventory/retalhos', data);
    return response.data;
  },

  consumeRetalho: async (id, data = {}) => {
    const response = await api.post(`/inventory/retalhos/${id}/consume`, data);
    return response.data;
  },

  reserveRetalho: async (id, data = {}) => {
    const response = await api.post(`/inventory/retalhos/${id}/reserve`, data);
    return response.data;
  },

  releaseRetalho: async (id) => {
    const response = await api.post(`/inventory/retalhos/${id}/release`);
    return response.data;
  },

  // ===== ITENS INDIVIDUAIS (PEÇAS E PEDAÇOS CORTADOS) =====
  getIndividualItemsByVariant: async (variantId) => {
    const response = await api.get(`/inventory/variants/${variantId}/individual-items`);
    return response.data;
  },

  updateIndividualItem: async (itemId, data) => {
    const response = await api.put(`/inventory/individual-items/${itemId}`, data);
    return response.data;
  },

  uploadIndividualItemPhoto: async (itemId, photoBase64) => {
    const response = await api.post(`/inventory/individual-items/${itemId}/photo`, { photo_base64: photoBase64 });
    return response.data;
  },

  generateMissingVariantItems: async (variantId, quantity) => {
    const response = await api.post(`/inventory/variants/${variantId}/generate-missing-items`, { quantity });
    return response.data;
  }
};

export default inventoryService;